import React from "react";
import { Skeleton } from "@mui/material";
import useBrandingAssets from "../../hooks/useBrandingAssets";

const CompanyLogo = ({ variant = "primary", skeletonWidth = 180, skeletonHeight = 60, ...imgProps }) => {
	const { primaryLogoUrl, secondaryLogoUrl, footerPrimaryLogoUrl, isReady } = useBrandingAssets();
	const src = variant === "secondary" ? secondaryLogoUrl : variant === "footerPrimary" ? footerPrimaryLogoUrl : primaryLogoUrl;

	if (!isReady) {
		return <Skeleton variant="rectangular" width={imgProps?.width || skeletonWidth} height={imgProps?.height || skeletonHeight} />;
	}

	return <img src={src} {...imgProps} />;
};

export default CompanyLogo;